import { Skeleton } from '@whistler-ui/k2/components/Skeleton';
import { Stack } from '@whistler-ui/k2/components/Stack';
import { Paragraph } from '@whistler-ui/k2/components/Typography';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { routes } from '../../../routes';
import { TStatuses } from '../../../types';
import { progressMessages } from '../../TestDetails/constants';

interface Props {
  status?: TStatuses;
}

export const TestDataPaneLoading = ({ status }: Props) => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const showProgress = pathname.includes(routes.entitlementsTestUseCase.url);

  const statusMsg = progressMessages[status];

  return (
    <section className="px-6">
      <Stack direction="column" className="max-w-2xl">
        <Stack direction="column" gap={6} className="pt-2 pb-6">
          <Skeleton width="60%" height={20} />
          <Skeleton width="25%" height={14} />
        </Stack>
        <Stack direction="row" gap={5}>
          <Stack direction="column" gap={2} className="flex-1">
            <Skeleton width="50%" height={16} />
            <Skeleton width="100%" height={30} />
          </Stack>
          <Stack direction="column" gap={2} className="flex-1">
            <Skeleton width="50%" height={16} />
            <Skeleton width="100%" height={30} />
          </Stack>
        </Stack>
        {showProgress && statusMsg && (
          <div className="flex justify-center">
            <Paragraph isBolder>{t(statusMsg)}</Paragraph>
          </div>
        )}
        <Stack direction="row" gap={5} className="pt-10">
          <Stack direction="column" gap={2} className="flex-1">
            <Skeleton width="50%" height={16} />
            <Skeleton width="100%" height={30} />
          </Stack>
          <Stack direction="column" gap={2} className="flex-1">
            <Skeleton width="50%" height={16} />
            <Skeleton width="100%" height={30} />
          </Stack>
        </Stack>
        <div className="mt-6">
          <Skeleton width="20%" height={40} />
        </div>
      </Stack>
    </section>
  );
};
